import { render, staticRenderFns } from "./PublisherInventorySection.vue?vue&type=template&id=279f1570&"
import script from "./PublisherInventorySection.vue?vue&type=script&lang=ts&"
export * from "./PublisherInventorySection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports